<template>
  <ak-field class="ak-project-select" label="Project" required>
    <template #helper>
      <ak-button size="tiny" @click="createProject">Create Project</ak-button>
    </template>
    <ak-select
      :model-value="selectedModel"
      :options="projects"
      track-by="_id"
      label="title"
      required
      @select="selectProject"
    />
  </ak-field>
</template>

<script>
import Field from '@akerolabs/akero-vue/src/components/field/Field.vue'
import Select from '@akerolabs/akero-vue/src/components/select/Select.vue'
import Button from '@akerolabs/akero-vue/src/components/button/Button.vue'
import CreateProjectModal from './CreateProjectModal.vue'
import { ModalProgrammatic } from '@akerolabs/akero-vue/src/components/modal'
import { request } from '@akerolabs/akero-vue/src/utils/request'
import { accountObj, agencyObj } from '@akerolabs/akero-vue/src/store'
import { defineComponent, ref, onMounted, computed } from 'vue'

export default defineComponent({
  name: 'AkProjectFormSelect',

  components: {
    [Field.name]: Field,
    [Select.name]: Select,
    [Button.name]: Button,
    [CreateProjectModal.name]: CreateProjectModal,
  },

  props: {
    id: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    },
  },

  emits: ['update:id', 'update:label', 'select'],

  setup(props, { emit }) {
    const projects = ref([])
    const selectedModel = ref(undefined)

    const computedModel = computed({
      get() {
        return props.id
      },
      set(val) {
        emit('update:id', val)
      },
    })

    const computedLabel = computed({
      get() {
        return props.label
      },
      set(val) {
        emit('update:label', val)
      },
    })

    const selectProject = (project) => {
      selectedModel.value = project
      computedModel.value = project._id
      computedLabel.value = project.title
      emit('select', { id: project._id, label: project.title })
    }

    const createProject = () => {
      ModalProgrammatic.open({
        component: CreateProjectModal,
        outerScroll: true,
        submitForm: createProjectCallback,
        size: 'large',
        props: {
          modelValue: {},
        },
      })
    }

    const createProjectCallback = (e, project) => {
      projects.value.push(project)
      selectProject(project)
    }

    const fetchProjects = async () => {
      const { data } = await request.get(`/campaigns`, {
        params: {
          account: accountObj()._id,
          agency: agencyObj()._id,
          deleted: JSON.stringify({ $ne: true }),
          archived: JSON.stringify({ $ne: true }),
          per_page: 0,
        },
      })
      projects.value = data.data
    }

    const setActiveProject = async () => {
      const project = projects.value.find((c) => {
        return c._id === props.id && c.title === props.label
      })
      if (project) {
        selectProject(project)
      }
    }

    onMounted(async () => {
      await fetchProjects()
      await setActiveProject()
    })

    return {
      computedModel,
      projects,
      selectProject,
      createProject,
      createProjectCallback,
      selectedModel,
      computedLabel,
    }
  },
})
</script>

<style lang="scss">
.ak-project-select {
  .ak-form-group__label {
    display: flex;
    .ak-form-label {
      flex-grow: 1;
    }
  }
}
</style>
